import { connect } from 'react-redux'
import LayoutMobileComponent from './component'

const mapStateToProps = state => ({})
const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutMobileComponent)